import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoteHrisSftpCsvSidebarQueryVariables = Types.Exact<{
  orgSftpIntegrationId: Types.Scalars['UUID']['input'];
  fileName: Types.Scalars['String']['input'];
}>;


export type RemoteHrisSftpCsvSidebarQuery = { __typename?: 'Query', RemoteHrisSftpCsv?: { __typename?: 'RemoteHrisSftpCsv', fileName: string, uploadedAt: string, size: number, csvContent: Array<{ [key: string]: any }> } | null };


export const RemoteHrisSftpCsvSidebarDocument = gql`
    query RemoteHrisSftpCsvSidebar($orgSftpIntegrationId: UUID!, $fileName: String!) {
  RemoteHrisSftpCsv(
    orgSftpIntegrationId: $orgSftpIntegrationId
    fileName: $fileName
  ) {
    fileName
    uploadedAt
    size
    csvContent
  }
}
    `;

/**
 * __useRemoteHrisSftpCsvSidebarQuery__
 *
 * To run a query within a React component, call `useRemoteHrisSftpCsvSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useRemoteHrisSftpCsvSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRemoteHrisSftpCsvSidebarQuery({
 *   variables: {
 *      orgSftpIntegrationId: // value for 'orgSftpIntegrationId'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useRemoteHrisSftpCsvSidebarQuery(baseOptions: Apollo.QueryHookOptions<RemoteHrisSftpCsvSidebarQuery, RemoteHrisSftpCsvSidebarQueryVariables> & ({ variables: RemoteHrisSftpCsvSidebarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RemoteHrisSftpCsvSidebarQuery, RemoteHrisSftpCsvSidebarQueryVariables>(RemoteHrisSftpCsvSidebarDocument, options);
      }
export function useRemoteHrisSftpCsvSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RemoteHrisSftpCsvSidebarQuery, RemoteHrisSftpCsvSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RemoteHrisSftpCsvSidebarQuery, RemoteHrisSftpCsvSidebarQueryVariables>(RemoteHrisSftpCsvSidebarDocument, options);
        }
export type RemoteHrisSftpCsvSidebarQueryHookResult = ReturnType<typeof useRemoteHrisSftpCsvSidebarQuery>;
export type RemoteHrisSftpCsvSidebarLazyQueryHookResult = ReturnType<typeof useRemoteHrisSftpCsvSidebarLazyQuery>;
export type RemoteHrisSftpCsvSidebarQueryResult = Apollo.QueryResult<RemoteHrisSftpCsvSidebarQuery, RemoteHrisSftpCsvSidebarQueryVariables>;